/**
 * The parameterHash of one loading element of the mass-and-balance rebuild,
 * derived from the element's content: flight, mission, load type, designator
 * and its parameter list, plus an ordinal for identical elements in one
 * rebuild. It replaced md5(flightId|timestamp), which gave every element new
 * rows on every recompute. With a content key an unchanged element keeps its
 * rows, and `focMain.initMassAndBalance` skips writing them.
 *
 * See loading-element-key.spec.ts for the full contract.
 */
export interface LoadingElementParam {
  tableSuffix: string;
  parameter: unknown;
  value: unknown;
}

export function loadingElementUid(
  md5: (s: string) => string,
  flightId: string,
  opsMissionType: number,
  codeType: number,
  designator: string,
  params: ReadonlyArray<LoadingElementParam>,
  seen: Map<string, number>
): string {
  const paramsCanonical: Array<[string, unknown, unknown]> = params.map((p) => [p.tableSuffix, p.parameter, p.value]);
  const withoutOrdinal = JSON.stringify([flightId, opsMissionType, codeType, designator, paramsCanonical]);

  const ordinal = seen.get(withoutOrdinal) ?? 0;
  seen.set(withoutOrdinal, ordinal + 1);

  const canonicalText = JSON.stringify([flightId, opsMissionType, codeType, designator, paramsCanonical, ordinal]);

  return md5(canonicalText).substring(0, 20);
}
